import { ComponentProps, ReactNode } from 'react';

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { cn } from 'utils/cn';

export const PolicyTable = ({
    footer,
    containerClassName,
    className,
    ...props
}: ComponentProps<typeof Table> & { footer?: ReactNode; containerClassName?: string }) => (
    <div className={cn('overflow-hidden rounded-[10px] border border-stone-200', containerClassName)}>
        <Table className={cn('text-cocoa-1000 text-sm', className)} {...props} />
        {footer && (
            <div className="flex flex-wrap items-center justify-between gap-4 border-t border-stone-100 px-6 py-4">
                {footer}
            </div>
        )}
    </div>
);

export const PolicyTableHeader = ({ className, ...props }: ComponentProps<typeof TableHeader>) => (
    <TableHeader className={cn('bg-stone-50 [&_tr]:border-stone-200', className)} {...props} />
);

export const PolicyTableHead = ({ className, ...props }: ComponentProps<typeof TableHead>) => (
    <TableHead
        className={cn(
            'text-cocoa-600 h-auto px-2 py-3 text-[11px] font-medium tracking-[0.08em] uppercase first:pl-6 last:pr-6',
            className,
        )}
        {...props}
    />
);

export const PolicyTableBody = TableBody;

export const PolicyTableRow = ({ className, ...props }: ComponentProps<typeof TableRow>) => (
    <TableRow className={cn('border-stone-100 hover:bg-transparent', className)} {...props} />
);

export const PolicyTableCell = ({ className, ...props }: ComponentProps<typeof TableCell>) => (
    <TableCell className={cn('px-2 py-2.5 first:pl-6 last:pr-6', className)} {...props} />
);
